import { Plan } from '../core/Plan'

export class Subscription {
	constructor (attributes) {
		var subscription = attributes

		if (!subscription) return null

		subscription.plan = subscription.plan ? new Plan(subscription.plan) : null

		for (let key in subscription) {
			this[key] = subscription[key]
		}
	}
}
